import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/foundation', label: 'Foundation' },
    { path: '/youtuber-program', label: 'YouTuber Program', highlight: true },
    { path: '/digimitra', label: 'DigiMitra' },
    { path: '/products', label: 'Products' },
    { path: '/services', label: 'Services' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/community', label: 'Community' },
    { path: '/donate', label: 'Donate' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav className="navbar" data-testid="navbar">
      <div className="nav-container">
        <div className="nav-brand-group">
          <Link to="/" className="nav-logo" data-testid="nav-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_digital-seniors-3/artifacts/fqevhgzz_Elderra%20logo%20new%20original%20%281%29.png" 
              alt="Elderra Logo"
              className="nav-logo-img"
            />
          </Link>

          {/* Incubation badge — next to brand */}
          <a
            href="https://nsrcel.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-incubation-badge"
            data-testid="nav-incubation-badge"
            title="Incubated at NSRCEL, IIM Bangalore"
          >
            <span className="nav-incubation-label">Incubated at</span>
            <img
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_95459019-fd40-417d-bf1f-43659b4169ce/artifacts/igzdcpvl_NSRCEL%20Main%20logo%20%282%29.webp"
              alt="IIM Bangalore · NSRCEL"
              className="nav-incubation-img"
            />
          </a>
        </div>

        {/* Desktop Navigation */}
        <div className="nav-links" data-testid="nav-links">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'active' : ''} ${link.highlight ? 'nav-link-highlight' : ''}`}
              data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="nav-mobile-toggle"
          onClick={() => setIsOpen(!isOpen)}
          data-testid="nav-mobile-toggle"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="nav-mobile-menu" data-testid="nav-mobile-menu">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-mobile-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
              data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;